import { appendIf } from '@btime/helpers'
import { assoc, compose, pick, prop } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { formsClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertForm($input: FormInput) {
    upsertForm(input: $input) {
      id
    }
  }
`
const cleanRequest = form => {
  return compose(
    pick([
      'checklistId',
      'name',
      'description',
      'access',
      'id',
      'placeType',
      'themeColor',
      'logoId',
      'redirectToExecution',
      'configuration'
    ]),
    assoc('checklistId', form.checklist?.id),
    assoc('logoId', form.logo?.id || null),
    assoc('themeColor', form.themeColor || null),
    assoc('redirectToExecution', !!form.redirectToExecution),
    assoc(
      'configuration',
      compose(
        JSON.stringify,
        pick(['titleMessage', 'bodyMessage']),
        item => assoc('titleMessage', prop('titleMessage', item), item),
        item => assoc('bodyMessage', prop('bodyMessage', item), item)
      )(form?.configuration)
    )
  )(form)
}

const validate = (form, setErrors, t) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: t('validations:required') }),
    ...appendIf(!form.description, { path: ['description'], message: t('validations:required') }),
    ...appendIf(!form.checklist?.id, { path: ['checklist'], message: t('validations:required') }),
    ...appendIf(!form.access, { path: ['access'], message: t('validations:required') })
    // ...appendIf(isPrivate && !form.placeType, { path: ['placeType'], message: t('validations:required') }),
    // ...appendIf(isPrivate && hasValidation && !form.validationPlaceField?.id, {
    //   path: ['validationPlaceField'],
    //   message: t('validations:required')
    // })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveUser = () => {
  const { t } = useTranslation('validations')
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Forms'], client: formsClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)

    const { setErrors } = actions
    const isValid = validate(form, setErrors, t)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
